<template>
  <asc-page-loading-indicator>
    <v-container fluid class="text-left">
      <v-row>
        <v-col cols="12" sm="12">
          <asc-page-header>
            <template #pageTitle>
              <asc-page-title title="maintenance data"></asc-page-title>
            </template>
          </asc-page-header>
          <div>
            <asc-plotly
              :plotly-data="mappedPlotlyData"
              :re-render="globalFilterAirline"
              :is-dirty="isPlotlyDirty"
              :is-render="true"
              :global-filter-airlines="globalFilterAirline"
            />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscPlotly from '@/components/molecules/AscPlotly'
import AscPageHeader from '@/components/atoms/AscPageHeader'
import AscPageTitle from '@/components/atoms/AscPageTitle'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import {
  PLOTLY_CONSTS as PLYC,
  GLOBAL_FILTER_CONSTS as GF,
  USER_CONSTS as UC,
} from '@/stores/consts'
import { REPEATERS } from '@/utilities/appConsts'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  name: 'AscMaintenanceDataContainer',

  components: {
    AscPlotly,
    AscPageHeader,
    AscPageTitle,
    AscPageLoadingIndicator,
  },

  data() {
    return {
      isDataLoading: true,
      globalFilterAirline: [],
      isPlotlyDirty: false,
    }
  },

  computed: {
    ...mapState(PLYC.NAMESPACE, ['plotlyTokens']),
    ...mapState(GF.NAMESPACE, ['globalFilter']),
    ...mapGetters(UC.NAMESPACE, ['mappedUserAirlines']),

    mappedPlotlyData() {
      return this.plotlyTokens['MaintenanceData']
    },
    mappedRepeaterAirline() {
      return this.mappedUserAirlines.filter(x =>
        x.phmAgreementTypes.includes(REPEATERS),
      )
    },
  },

  watch: {
    globalFilter: {
      deep: true,
      handler() {
        this.getAirlineFilter()
      },
    },
  },

  async mounted() {
    if (this.globalFilter.selections.length > 0) {
      let selectedGlobalFilterData = this.mappedRepeaterAirline.filter(mra =>
        this.globalFilter.selections.some(gf => gf.airlineId == mra.airlineId),
      )
      this.globalFilterAirline = [
        ...new Set(selectedGlobalFilterData.map(x => x.airlineName)),
      ]
    }
    if (this.globalFilter.allSelected) {
      this.globalFilterAirline = [
        ...new Set(this.mappedRepeaterAirline.map(x => x.airlineName)),
      ]
    }
    await this[PLYC.GET_PLOTLY_TOKEN]({
      data: {
        MaintenanceData: this.globalFilterAirline,
      },
      type: 'MaintenanceData',
    })
  },

  methods: {
    ...mapActions(PLYC.NAMESPACE, [PLYC.GET_PLOTLY_TOKEN]),

    getAirlineFilter() {
      if (this.globalFilter.selections.length > 0) {
        let selectedGlobalFilterData = this.mappedRepeaterAirline.filter(mra =>
          this.globalFilter.selections.some(
            gf => gf.airlineId == mra.airlineId,
          ),
        )
        this.globalFilterAirline = [
          ...new Set(selectedGlobalFilterData.map(x => x.airlineName)),
        ]
      }
      if (this.globalFilter.allSelected) {
        this.globalFilterAirline = [
          ...new Set(this.mappedRepeaterAirline.map(x => x.airlineName)),
        ]
      }

      this.isPlotlyDirty = true
    },
  },
}
</script>
